import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./components/user/Login";
import DashBoard from "./Pages/DashBoard/DashBoard";
import ProductCategory from "./Pages/Masters/ProductCategory/ProductCategory";
import SubProductCategory from "./Pages/Masters/SubProductCategory/SubProductCategory";
import Categorys from "./Pages/Products/Categorys/Categorys";
import SubCategorys from "./Pages/Products/SubCategorys/SubCategorys";
import CategorysDetial from "./Pages/Products/Categorys/CategorysDetial/CategorysDetial";
import SubCategorysDetial from "./Pages/Products/SubCategorys/SubCategorysDetial/SubCategorysDetial";
import UnderSubProductCategoryDetial from "./Pages/Products/UnderSubProductCategory/UnderSubProductCategoryDetial/UnderSubProductCategoryDetial";
import EditCategory from "./Pages/Products/Categorys/EditCategory/EditCategory";
import EditUnderSubProductCategory from "./Pages/Products/UnderSubProductCategory/EditUnderSubProductCategory/EditUnderSubProductCategory";
import EditSubCategory from "./Pages/Products/SubCategorys/EditSubCategory/EditSubCategory";
import UnderSubProductCategory from "./Pages/Products/UnderSubProductCategory/UnderSubProductCategory";

import "./index.css"


import NewProducts from "./Pages/Products/NewProducts/NewProducts";
import Register from "./components/user/Register";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";



import Filters from "./Pages/Products/Filters/Filters";
import { AuthProvider } from "./components/Token";
import FiltersDetials from "./Pages/Products/Filters/FiltersDetials";
import FilterViewPage from "./Pages/Products/Filters/FilterViewPage";
import FilterEdit from "./Pages/Products/Filters/FilterEdit";

import FiltersTypes from "./Pages/Products/Filters/FiltersTypes/FiltersTypes";
import EditFiltersTypes from "./Pages/Products/Filters/FiltersTypes/EditFiltersTypes";
import ViewFiltersTypes from "./Pages/Products/Filters/FiltersTypes/ViewFiltersTypes";
import UpdateFiltersTypes from "./Pages/Products/Filters/FiltersTypes/UpdateFiltersTypes";
import ScrollTop from "./components/ScrollTop";
// import OrderProducts from "./Pages/DashBoard/orderProducts/OrderProducts";
import AddCoupen from "./Pages/Coupon/AddCoupen";
import EditPropertyForm from "./Pages/Coupon/EditPropertys";
import DetialCoupen from "./Pages/Coupon/DetialCoupen";
import UpdateCoupen from "./Pages/Coupon/UpdateCoupen";
import userContext from "./components/UseContext/UseContext";
import ErrorBoundary from "./components/ErrorBoundary";
import ViewProperty from "./Pages/Coupon/ViewPropertyDetails"
import PropertyView from "./Pages/Coupon/AddCoupen";
import EditNewProducts from "./Pages/Coupon/EditPropertys";
import MyGallery from "./Pages/Coupon/ViewPropertyDetails";

function App() {
  
  useEffect(() => {
    localStorage.getItem("accessToken");
  }, []);

  const [logOut, setLogOut] = useState(false);

  const defaultValue = {
    logOut,
    setLogOut,
  };

  return (
    <ErrorBoundary>
      <userContext.Provider value={defaultValue}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* <Route index element={<Register />} /> */}
              <Route path="/login" element={<Login />} />

              <Route path  ="/EditNewProducts/:id" element={<EditNewProducts />} />
              <Route path="/" element={<Layout />}>
                <Route path="/profilepage" element={<ProfilePage />} />
                <Route index element={<DashBoard />} />
              
              
                {/* Property */}
                <Route path="/mygallery/:id" element={<MyGallery />} />
                <Route path="/PropertyView" element={<PropertyView />} />
                <Route path="/viewproperty" element={<ViewProperty/>} />
                <Route path="/EditPropertyForm" element={<EditPropertyForm />} />
                 <Route path="/propertyDetails/:id"  element={<CategorysDetial/>}/>
                <Route path="/detialCoupen/:_id" element={<DetialCoupen />} />
                <Route path="/updateCoupen/:_id" element={<UpdateCoupen />} />

                {/* master property type */}
                <Route path="/productcategory" element={<ProductCategory />} />
                <Route
                  path="/subproductcategory"
                  element={<SubProductCategory />}
                />
                <Route
                  path="/underSubProductCategory"
                  element={<UnderSubProductCategory />}
                />
                <Route path="/category" element={<Categorys />} />
                <Route path="/subcategory" element={<SubCategorys />} />
                <Route
                  path="/categorysDetial/:_id"
                  element={<CategorysDetial />}
                />
                <Route
                  path="/subCategorysDetial/:_id"
                  element={<SubCategorysDetial />}
                />
                <Route
                  path="/underSubCategorysDetial/:_id"
                  element={<UnderSubProductCategoryDetial />}
                />
                <Route path="/editCategory/:_id" element={<EditCategory />} />
                <Route
                  path="/editUnderSubProductCategory/:_id"
                  element={<EditUnderSubProductCategory />}
                />
                <Route
                  path="/editSubCategory/:_id"
                  element={<EditSubCategory />}
                />
              
              
               
             
              
    
            
                <Route path="/newProducts" element={<NewProducts />} />
             

              

                <Route path="/filters" element={<Filters />} />
                <Route path="/filtersDetials" element={<FiltersDetials />} />
                <Route
                  path="/filterViewPage/:_id"
                  element={<FilterViewPage />}
                />
                <Route path="/filterEdit/:_id" element={<FilterEdit />} />
                <Route path="/filtersTypes" element={<FiltersTypes />} />
                <Route
                  path="/editFiltersTypes"
                  element={<EditFiltersTypes />}
                />
                <Route
                  path="/viewFiltersTypes/:_id"
                  element={<ViewFiltersTypes />}
                />
                <Route
                  path="/updateFiltersTypes/:_id"
                  element={<UpdateFiltersTypes />}
                />
                {/* <Route path="/orderProducts" element={<OrderProducts />} /> */}
              </Route>
            </Routes>
            <ScrollTop />
          </BrowserRouter>
        </AuthProvider>
      </userContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
